import React from "react";
import SearchForm from "../ui/form/art/SearchForm";

export default function ArtSearchForm() {
    return (
        <SearchForm/>
    );
}
